const NL = {
  water_status: { low: "Laag (gunstig)", moderate: "Matig", severe: "Ernstig", extreme: "Extreem (kritisch)" },
  internet_class: { fiber: "Glasvezel", mixed: "Gemengd (fiber + 4G)", "4G_only": "Alleen 4G", weak: "Zwak / instabiel" },
  expat_density: { very_high: "Zeer hoog", high: "Hoog", moderate: "Matig", low: "Laag" },
  fit_score: { strong: "Sterke match", good: "Goede match", caveats: "Met aandachtspunten", caution: "Oppassen" },
  fire_risk_class: { 1: "Zeer laag", 2: "Laag", 3: "Matig", 4: "Hoog", 5: "Zeer hoog" },
};

export function loc(field, value, fallback = "—") {
  if (value == null) return fallback;
  const table = NL[field];
  return table?.[value] ?? value;
}

export function locAL(open) {
  if (open === true) return "Open — nieuwe registraties mogelijk";
  if (open === false) return "Gesloten / quotum bereikt";
  return "Onbekend";
}

export function locFire(n) {
  if (n == null) return "—";
  return `${NL.fire_risk_class[n] || n} (klasse ${n}/5)`;
}

export function climateBucket(c) {
  if (!c) return "unknown";
  const days = c.heat_days_35 ?? 0;
  const p95 = c.summer_max_p95 ?? 30;
  if (days <= 8 && p95 <= 33) return "cool";
  if (days <= 16 && p95 <= 36) return "mild";
  if (days <= 24 && p95 <= 38) return "warm";
  if (days <= 30 && p95 <= 40) return "hot";
  return "extreme";
}

export function prettyConcelho(c) {
  if (!c) return "";
  return c.split("-").map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(" ");
}

export function formatEUR(n) {
  return n != null ? "€ " + n.toLocaleString("nl-NL") : "—";
}

export function formatArea(m2) {
  if (!m2) return "?";
  if (m2 >= 10000) return (m2 / 10000).toFixed(1).replace(".", ",") + " ha";
  return m2.toLocaleString("nl-NL") + " m²";
}

export function fmtEurCompact(n) {
  if (n == null) return "—";
  const sign = n < 0 ? "−" : "";
  const abs = Math.abs(n);
  if (abs >= 1000) return sign + "€ " + Math.round(abs / 1000).toLocaleString("nl-NL") + "k";
  return sign + "€ " + abs.toLocaleString("nl-NL");
}
